// Custom Kendo Error Handler (ESM version)
// Provides exported functions plus an optional global shim for legacy Razor inline usage.

let popupNotification = null;
let notificationSelector = '#MainErrorPopupNotification';

function ensurePopup() {
    if (!popupNotification) {
        const el = window.jQuery ? window.jQuery(notificationSelector) : null;
        if (el && el.length) {
            popupNotification = el.data('kendoNotification');
        }
    }
    return popupNotification;
}

export function configure({ selector } = {}) {
    if (selector) {
        notificationSelector = selector;
        popupNotification = null; // force re-resolve on next use
    }
}

export function initNotifications() {
    ensurePopup();
}

export function showPopup(message, type = 'info') {
    const popup = ensurePopup();
    if (!popup) return; // fail-soft if not ready
    popup.show(message, type);
}

export function showPopupForErrors(errors) {
    if (!errors) return;
    const popup = ensurePopup();
    if (!popup) return;
    window.jQuery.each(errors, function (_key, value) {
        if ('errors' in value) {
            window.jQuery.each(value.errors, function () {
                popup.show(this, 'error');
            });
        }
    });
}

export function gridCrudSuccessMsg(onRequestEndEvent, entityName) {
    if (!onRequestEndEvent || onRequestEndEvent.response?.Errors) return;
    switch (onRequestEndEvent.type) {
        case 'update':
            showPopup(`${entityName} successfully updated.`, 'success');
            break;
        case 'create':
            showPopup(`${entityName} successfully created.`, 'success');
            break;
        case 'destroy':
            showPopup(`${entityName} successfully deleted.`, 'success');
            break;
    }
}

export function gridEditorValidationSummary(errors, gridName) {
    if (!errors || !gridName) return;
    const $ = window.jQuery;
    const grid = $("#" + gridName).data('kendoGrid');
    if (!grid) return;
    grid.one('dataBinding', function (e) {
        e.preventDefault();
        window.jQuery.each(errors, function (_key, value) {
            let message = '';
            if ('errors' in value) {
                window.jQuery.each(value.errors, function () {
                    message += `<li>${this}</li>`;
                });
            }
            grid.editable.element
                .find('[data-valmsg-summary="true"]')
                .html(`<ul>${message}</ul>`);
        });
    });
}

export function popupWindowValidationSummary(errors, kendoWindowInstance) {
    if (!errors || !kendoWindowInstance) return;
    window.jQuery.each(errors, function (_key, value) {
        let message = '';
        if ('errors' in value) {
            window.jQuery.each(value.errors, function () {
                message += `<li>${this}</li>`;
            });
        }
        kendoWindowInstance.element
            .find('[data-valmsg-summary="true"]')
            .html(`<ul>${message}</ul>`);
    });
}

// Backward-compatible global shim
(function attachGlobal() {
    if (typeof window === 'undefined') return;
    if (!window.CustomKendoErrorHandler) {
        window.CustomKendoErrorHandler = {
            configure,
            initNotifications,
            showPopup,
            showPopupForErrors,
            GridCrudSuccessMsg: gridCrudSuccessMsg,
            GridEditorValidationSummary: gridEditorValidationSummary,
            popupWindowValidationSummary,
        };
    }
})();
